import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert , MDBCard, MDBFooter,
    MDBCardBody,
    MDBCardImage,
    MDBCardTitle,
    MDBCardText } from 'mdbreact';
  import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBFormInline, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem } from 'mdbreact';
  import { Form, Input, Button, Checkbox, message } from 'antd';
  import logo2 from '../img/mmu.png'
  import Swal from 'sweetalert2'
  import { format } from "date-fns";
  import {isMobile, browserName, osName, OsTypes } from 'react-device-detect';
  import FadeIn from 'react-fade-in';


export default class Loginforapp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            Psaaword:'',
            modal: false,
            collapse: false,
            isWideEnough: false,
            modalpdpa: false,
            admin_type:'',
            admin_typepdpa:'',
            encodedcitizen:'',
            url:'',
            device:'',
            osName:'',
            browsername:'',
            datelogin:'',
            timelogin:'',
            projectname:'ระบบ DASHBORAD',

        };
        this.handleChange = this.handleChange.bind(this);
        this.handleChange2 = this.handleChange2.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
         this.handleSubmitgoogle = this.handleSubmitgoogle.bind(this);
        // this.toggle = this.toggle.bind(this);
        // this.onClick = this.onClick.bind(this);
        // this.getpdpa = this.getpdpa.bind(this);
        // this.togglepdpa = this.togglepdpa.bind(this);
      }


    handleChange(event) {    this.setState({value: event.target.value});  }
    handleChange2(event) {    this.setState({Psaaword: event.target.value});  }

    handleSubmit(event) {
        event.preventDefault();

        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        datafrm.append("txtemail", this.state.value);
        datafrm.append("txtpass", this.state.Psaaword);

        
        const user = {
         "txtemail": this.state.value,
         "txtpass": this.state.Psaaword
       };

        fetch('https://mua.kpru.ac.th/FrontEnd_Mis/login/login/', {
         method: 'POST',
         body: JSON.stringify(user),
         headers: {
       
         }
       })
         .then(res => res.json())
         .then((res) => {
             console.log(res);
          //   if (res[0].loginstatus === "1" && res[0].employee_id === "000512" || res[0].employee_id === "000961" || res[0].employee_id === "001334" || res[0].employee_id === "001322" || res[0].employee_id === "000026" || res[0].employee_id === "000096" || res[0].employee_id === "000970" || res[0].employee_id === "001025" ) {
          if( res[0].loginstatus === "1"){
               //  alert("เข้าสู่ระบบสำเร็จ")


                  localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
     
                  message.success("เข้าสู่ระบบสำเร็จ")
                  localStorage.setItem('loginstatus', res[0].loginstatus);
                  localStorage.setItem('type2', res[0].employee_id);
                  localStorage.setItem('admin_type', 2);

                  const  now = new Date();
                  const  now2 = new Date();
                  //  now.setMinutes(now.getMinutes() + 3); //บวกเวลาล็อกเอ้า
                  const wanwela = new Date(now)
                  const formattedDate = format(wanwela, "MMMM do, yyyy H:mma");

                  now2.setMinutes(now.getMinutes() + 30); //บวกเวลาล็อกเอ้า
                  const wanwela2 = new Date(now2)
                  const formattedDate2 = format(wanwela2, "MMMM do, yyyy H:mma");
                  localStorage.setItem('timeout', formattedDate2 );
                
          
             window.location.href = '/info/Studentkpru'
             }else{
                // message.error("เข้าสู่ระบบไม่สำเร็จ")
                Swal.fire(
                 'ไม่สามารถเข้าถึงระบบได้',
                 'กรุณาลองอีกครั้ง',
                 'question'
               )
               //  window.location.href = '/'
             }
           
         })
         .catch(err => {
           console.log('request failed', err);
         })  
    }



    handleSubmitgoogle(event) {
      event.preventDefault();

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("txtemail", this.state.value);
      datafrm.append("device", this.state.device);
      datafrm.append("osName", this.state.osName);
      datafrm.append("browsername", this.state.browsername);
      datafrm.append("datelogin", this.state.datelogin);
        datafrm.append("timelogin", this.state.timelogin);
 datafrm.append("projectname", this.state.projectname);
        
      const user = {
       "txtemail": this.state.value,
       "txtpass": this.state.Psaaword
     };
     const scriptUrl = "https://script.google.com/macros/s/AKfycbwDExNA6bBUcZpTY31HVfPZVh-QLU8dCwEXWJ44HgrYghzJXQhlUYkx6NlNXybQdAVKWg/exec"

    //   fetch('https://script.google.com/macros/s/AKfycbxrmHBDOfjqIdqWJezBEv31CYlkSm2fX2raGzBfZRXUKVISVQajMgreDf6dQSAYB6BJ4A/exec', {
    //    method: 'POST',
    //    body: datafrm,
    //    headers: {
     
    //    }
    //  })
    fetch(scriptUrl, {method: 'POST', body: datafrm})
    .then(res => {
        console.log("SUCCESSFULLY SUBMITTED")
    })
     
       .catch(err => {
         console.log('request failed', err);
       })
   
  }



  componentDidMount(){
    console.log( this.state.projectname)
   
    if (isMobile) {
      const moment = require('moment');
      const  now = new Date();
      const formattedDate =moment(now).format('YYYY-MM-DD');
      const formattedtime =moment(now).format('HH:mm');
     // return <div> This content is available only on mobile</div>
      console.log('mobile')
      console.log(browserName)
      console.log(osName)
      console.log(formattedDate)

    
     this.setState({
      device: 'mobile',
      browsername: browserName,
      datelogin : formattedDate,
      timelogin : formattedtime,
      osName : osName,
    });

    }else{
       console.log('browser')
       console.log(browserName)
       console.log(osName)
       
      const moment = require('moment');
      const  now = new Date();
      const formattedDate =moment(now).format('YYYY-MM-DD HH:mm:ss');
      const formattedtime =moment(now).format('HH:mm');

      console.log(formattedDate)

      this.setState({
        device: 'browser',
        browsername: browserName,
        datelogin : formattedDate,
        timelogin : formattedtime,
        osName : osName,
      });
       
    }


    const {user1} = this.props.match.params;
    const {pass} = this.props.match.params;
 
    const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
    datafrm.append("txtemail", this.state.value);
    datafrm.append("txtpass", this.state.Psaaword);

 
    console.log('pass')
    const user = {
     "txtemail": user1,
     "txtpass": pass
   };

    fetch('https://mua.kpru.ac.th/FrontEnd_Mis/login/login/', {
     method: 'POST',
     body: JSON.stringify(user),
     headers: {
   
     }
   })
     .then(res => res.json())
     .then((res) => {
         console.log(res);
      //   if (res[0].loginstatus === "1" && res[0].employee_id === "000512" || res[0].employee_id === "000961" || res[0].employee_id === "001334" || res[0].employee_id === "001322" || res[0].employee_id === "000026" || res[0].employee_id === "000096" || res[0].employee_id === "000970" || res[0].employee_id === "001025" ) {
      if( res[0].loginstatus === "1"){
           //  alert("เข้าสู่ระบบสำเร็จ")


              localStorage.setItem('name', res[0].frist_name +"  "+ res[0].last_name);
 
              message.success("เข้าสู่ระบบสำเร็จ")
              localStorage.setItem('loginstatusdashboard', res[0].loginstatus);
              localStorage.setItem('type2', res[0].employee_id);
              localStorage.setItem('admin_type', 2);
              localStorage.setItem('organization_name', res[0].organization_name);

              const  now = new Date();
              const  now2 = new Date();
              //  now.setMinutes(now.getMinutes() + 3); //บวกเวลาล็อกเอ้า
              const wanwela = new Date(now)
              const formattedDate = format(wanwela, "MMMM do, yyyy H:mma");

              now2.setMinutes(now.getMinutes() + 30); //บวกเวลาล็อกเอ้า
              const wanwela2 = new Date(now2)
              const formattedDate2 = format(wanwela2, "MMMM do, yyyy H:mma");
              localStorage.setItem('timeout', formattedDate2 );
            
      
              window.location.href = '/welcome'
         }else{
            // message.error("เข้าสู่ระบบไม่สำเร็จ")
            Swal.fire(
             'ไม่สามารถเข้าถึงระบบได้',
             'กรุณาลองอีกครั้ง',
             'question'
           )
           //  window.location.href = '/'
         }
       
     })
     .catch(err => {
       console.log('request failed', err);
     })  




  }


  render() {
    return (
    
        
        <div  style={{ height: '90vh' }}>

                {/* <MDBContainer fluid style={{ backgroundImage:`url(${sa2})`, maxWidth: "100%", maxWidth: "100%", width:"100", paddingTop: 20 }}   > */}
                <MDBContainer fluid className="bg3"   >
                {/* <MDBNavbar color="orange darken-4" dark expand="md">
                    <MDBNavbarBrand>
                      <strong className="white-text">KPRU DATA DASHBORAD</strong>
                    </MDBNavbarBrand>
                    <MDBNavbarToggler onClick={this.toggleCollapse} />
                    <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
                    </MDBCollapse>
                  </MDBNavbar> */}
        
<br/><br/><br/><br/>
                    <MDBRow>
                    <MDBCol xl="4">
                    </MDBCol>
                        <MDBCol xl="4">
 {/* <div className="card88  transbox"> */}
 {/* <div  className=" n "> */}
 <FadeIn>
 <div className=" ml-4 mr-4 mt-5 transbox"  >

  
                        <MDBCardBody >
                         <div className="ml-4 mr-4 mt-5 " >  
                         
                            <MDBView hover zoom>
                            <img src={logo2} className="rounded  mx-auto d-block w-10" alt="aligment" width={120}/><br/>
                            </MDBView>
                        <form onSubmit={this.handleSubmit}>
                         {/* <form onSubmit={this.handleSubmitgoogle}> */}
                            <p className="font-weight-bold h3 text-center deep-orange-text">เข้าสู่ระบบ  DASHBORAD</p>
                            <p className="h5 text-center deep-orange-text">มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
                            <div className="deep-orange-text">
                            <MDBInput label="Usernamecc" icon="user" group type="text" validate error="wrong"
                                success="right" className="deep-orange-text"  name="Username" value={this.state.value} onChange={this.handleChange}/>

                            <MDBInput label="Password" icon="key" group type="password" validate error="wrong"
                                success="right"  className="deep-orange-text"  value={this.state.Psaaword} onChange={this.handleChange2} />

                            </div>
                            <div className="text-center">
                            <MDBBtn color="elegant" dark type="submit" value="Submit" >
                             เข้าสู่ระบบ
                                <MDBIcon far icon="paper-plane" className="ml-1" />
                            </MDBBtn>
                            </div>
                        </form>
                       
                         </div>
                        </MDBCardBody>
                        {/* </MDBCard> */}
                        <h6 className="grey-text text-right">Online by : {this.state.osName}</h6>
                   </div>   
                   </FadeIn>    
                
                        </MDBCol>
                        <MDBCol xl="4">
                          {/* <div>
                          <img src={logo2} className="rounded  mx-auto d-block w-10" alt="aligment" width={120}/>
                          </div> */}
                        </MDBCol>
    
                    </MDBRow>


                    {/* <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
      
                      <MDBModalBody className="text-center">
                      <MDBIcon icon="exclamation-circle" className="red-text text-center" size="5x" />
                      <h3>usermame หรือ password ไม่ถูกต้อง</h3>
                      <h3>กรุณาตรวจสอบความถูกต้อง อีกครั้ง!</h3>
                      </MDBModalBody>
                    </MDBModal> */}
    

                    </MDBContainer>
          
             {/* <footer className="footer--pin">
                                <MDBFooter color="orange darken-4" className="font-small  "  >
                               
                                    <MDBRow>
                                      <MDBCol md="12">
                                        <h5 className="title text-center">Kamphaeng Phet Rajabhat University</h5>
                                      </MDBCol>
                                    
                                    </MDBRow>
                                
                                  <div className="footer-copyright text-center py-3">
                                    <MDBContainer fluid>
                                      &copy; {new Date().getFullYear()} Copyright: <a href="https://www.kpru.ac.th/"> www.kpru.ac.th </a>
                                    </MDBContainer>
                                  </div>
                                </MDBFooter>
             </footer> */}



                    {/* </MDBJumbotron> */}
                    </div>
     
                  
       


      
    )
  }
}
